import { Box } from '@mui/material';
import { LwButton } from 'redesign';
import { IconApproved, IconCancel } from 'assets/img';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { useExternalParams } from 'shared/hooks';
import { useEditDocumentFormActions } from './hooks/use-edit-document-form-actions/use-edit-document-form-actions';
import { EditDocumentFormData } from '../edit-document-form-content/edit-document-content.types';
import { DOCUMENTS_INITIAL_VALUES, mapToDocumentStatus } from '../../documents-page/documents-type';

export const EditDocumentFormToolbox = () => {
  const [params] = useExternalParams(DOCUMENTS_INITIAL_VALUES);
  const { t } = useTranslation(['web-common', 'hq-screen-specific']);
  const formMethods = useFormContext<EditDocumentFormData>();
  const { handleEditDocument, handleCancel } = useEditDocumentFormActions({
    documentId: params.documentId,
    status: mapToDocumentStatus(params.status),
    documentType: params.documentType,
    name: params.name,
  });

  const handleFormSubmit = () => {
    formMethods.handleSubmit(handleEditDocument)();
  };

  return (
    <>
      <Box>
        <LwButton
          type="submit"
          iconColorMode="stroke"
          color="primary"
          startIcon={<IconApproved />}
          onClick={handleFormSubmit}
          disabled={formMethods.formState.isSubmitting}
        >
          {t('buttons.submit', { ns: 'web-common' })}
        </LwButton>
      </Box>
      <Box>
        <LwButton
          onClick={handleCancel}
          iconColorMode="fill"
          color="secondary"
          startIcon={<IconCancel />}
        >
          {t('buttons.cancel', { ns: 'web-common' })}
        </LwButton>
      </Box>
    </>
  );
};
